<template>
  <div class="wrap">
    <!-- 头部 -->
    <m-header :activeIndex="2"></m-header>
    <!-- 内页banner -->
    <m-banner :imageUrl="'1'"></m-banner>
    <div class="container">
      <!-- 面包屑 -->
      <m-breadcrumb :list="['首页', '捐赠征集']"></m-breadcrumb>
      <div class="title-wrap">
        <div class="title">{{ dataItem.title }}</div>
        <div class="date">{{ dataItem.collectDate }}</div>
      </div>
      <div class="detail-wrap" v-html="dataItem.content"></div>
      <div class="alist-wrap">
        <a
          class="a-wrap"
          v-for="item in fileList"
          :key="item.id"
          @click="handleAhtmlGourl(item)"
          v-text="item.name"
        ></a>
      </div>
    </div>
    <!-- 底部信息 -->
    <m-fotter></m-fotter>
  </div>
</template>

<script>
import MHeader from "@/components/MHeader";
import MFotter from "@/components/MFotter";
import MBanner from "@/components/MBanner";
import MBreadcrumb from "@/components/MBreadcrumb";
import { getCollectDetail } from "@/api/collect";
import { STATUS_CODE_OK } from "@/config";
export default {
  name: "CollectDetail",
  data() {
    return {
      id: "",
      dataItem: "",
      fileList: [],
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.handleGetCollectDetail();
  },
  methods: {
    handleAhtmlGourl(item) {
      let url = item.url;
      fetch(url)
        .then((res) => res.blob())
        .then((blob) => {
          const a = document.createElement("a");
          const objectUrl = window.URL.createObjectURL(blob);
          a.download = item.name;
          a.href = objectUrl;
          a.click();
          window.URL.revokeObjectURL(objectUrl);
          a.remove();
        });
    },
    async handleGetCollectDetail() {
      let { data } = await getCollectDetail({
        id: this.id,
      });
      if (data.code === STATUS_CODE_OK) {
        this.dataItem = data.data;
        this.fileList = data.data.fileList;
      }
    },
  },
  components: {
    MHeader,
    MFotter,
    MBanner,
    MBreadcrumb,
  },
};
</script>

<style scoped lang="scss">
.detail-wrap {
  padding: 20px 0 40px 0;
}
.title-wrap {
  margin-top: 40px;
  .title {
    text-align: center;
    font-size: 16px;
  }
  .date {
    text-align: end;
    color: #606266;
  }
}
.alist-wrap {
  width: 50%;
  padding-bottom: 40px;
  font-size: 16px;
  .a-wrap {
    padding: 10px;
    display: block;
  }
}
</style>
